import { Terminal } from './types/classes/Terminal';
import { FDetailShift } from './types/FDetailShift';
import { TJournalisation } from './types/TJournalisation';
import { VShift } from './types/VShift';

type DateFieldKeys<T> = {
    [K in keyof T]: T[K] extends Date | null ? K : never;
}[keyof T];

export function convertDates<T extends object>(obj: T, dateFields: readonly DateFieldKeys<T>[]): T {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, dateFields.includes(key as DateFieldKeys<T>) && value ? new Date(value) : value])) as T;
}

// ---

const terminalDateFields = ['dateMiseEnService', 'dateEnregistrement'] as const satisfies readonly (keyof Terminal)[];
export function convertTerminalDates(terminal: Terminal): Terminal {
    return convertDates(terminal, terminalDateFields);
}

const vShiftDateFields = ['dateShift', 'dateOuverture', 'dateCloture'] as const satisfies readonly (keyof VShift)[];
export function convertShiftDates(shift: VShift): VShift {
    return convertDates(shift, vShiftDateFields);
}

const detailShiftDateFields = [] as const satisfies readonly (keyof FDetailShift)[];
export function convertDetailShiftDates(shift: FDetailShift): FDetailShift {
    return convertDates(shift, detailShiftDateFields);
}

const journalisationDateFields = [] as const satisfies readonly (keyof TJournalisation)[];
export function convertJournalisationDates(journalisation: TJournalisation): TJournalisation {
    return convertDates(journalisation, journalisationDateFields);
}
